import { projectService } from '@/services/project/project-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';

export const useSensitiveValuesSwitchQuery = (projectId: string) => {
  const query = useQuery({
    queryKey: projectKeys.details({ projectId }),
    queryFn: () => projectService.getProjectDetails(projectId),
  });
  return { data: { query } };
};
